import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "visitors-milestone-full-grid page-full-height" }
const _hoisted_2 = { class: "visitors-milestone-full-grid__main-wrapper" }
const _hoisted_3 = { class: "visitors-milestone-full-grid__header" }
const _hoisted_4 = { class: "visitors-milestone-full-grid__header-left" }
const _hoisted_5 = { class: "visitors-milestone-full-grid__title" }
const _hoisted_6 = { class: "visitors-milestone-full-grid__title-text" }
const _hoisted_7 = { class: "visitors-milestone-full-grid__title-text" }
const _hoisted_8 = { class: "visitors-milestone-full-grid__header-right" }
const _hoisted_9 = { class: "visitors-milestone-full-grid__grid-wrapper" }
const _hoisted_10 = { class: "visitors-milestone-full-grid__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxAvatar = _resolveComponent("PxAvatar")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_LastAssessmentDate = _resolveComponent("LastAssessmentDate")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_MilestonesFullGrid = _resolveComponent("MilestonesFullGrid")!
  const _component_GridLegend = _resolveComponent("GridLegend")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_PxAvatar, {
              name: _ctx.company.name,
              photo: _ctx.company.logo,
              size: 24,
              class: "visitors-milestone-full-grid__company-logo"
            }, null, 8, ["name", "photo"]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.company.name), 1),
            _createVNode(_component_PxIcon, {
              class: "visitors-milestone-full-grid__arrow-separator",
              name: "arrow--right-black",
              size: "12"
            }),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("milestonePlanner.label")), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "visitors-milestone-full-grid__title-separator" }, null, -1)),
            _createVNode(_component_LastAssessmentDate, { date: _ctx.lastAssessmentDate }, null, 8, ["date"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_PxButton, _mergeProps(_ctx.$options.static.printButton, {
            ref: "printButton",
            onClick: _ctx.printGrid
          }), null, 16, ["onClick"]),
          _createVNode(_component_PxButton, _mergeProps(_ctx.$options.static.collapseButton, {
            ref: "collapseFullGridButton",
            onClick: _ctx.collapseFullGrid
          }), null, 16, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_MilestonesFullGrid, {
          ref: "milestonesFullGrid",
          categories: _ctx.gridCategories,
          "current-level": _ctx.lastAssessment.level.value,
          levels: _ctx.levels
        }, null, 8, ["categories", "current-level", "levels"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_LastAssessmentDate, { date: _ctx.lastAssessmentDate }, null, 8, ["date"]),
        _createVNode(_component_GridLegend, { class: "visitors-milestone-full-grid__grid-legend" })
      ])
    ])
  ]))
}